/* eslint-disable react/no-array-index-key */
import React from 'react';

/* External */
import { Box, Tooltip } from '@material-ui/core';

/* Project */
import './styles.css';

export function Row({ row, headerList, handleOnClick, isMobileDevice }) {
  return (
    <Box className="table-row" onClick={() => handleOnClick()}>
      {row.map((info, index) => (
        <Box
          key={`row-item-${index}`}
          className="table-row__item"
          style={{
            order: isMobileDevice ? headerList[index].mobileOrder : 0,
            width: headerList[index].width,
            cursor: 'pointer',
            justifyContent: 'flex-start',
          }}>
          {info.icon ? (
            <Tooltip title={headerList[index].name} placement="top">
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'left',
                  alignItems: 'center',
                  marginRight: '5px',
                }}>
                {info.icon}
              </div>
            </Tooltip>
          ) : null}
          <Box
            style={{
              overflow: 'hidden',
            }}>
            {info.value}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
